<!-- 
RecentCustList.vue
功能：近期動態客戶列表
作者：i9400538 陳博承
完成：2021-08-09
-->
<template>
  <main class="container-fluid">
    <section class="margin-left-10">
      <h4 class="text-green">客戶列表：{{ tableDataBackup.length }}位客戶</h4>
      <div class="form-group row search-checkbox margin-buttom-0">
        <label class="d-inline-block pt-2">客戶類型(可複選)：</label>
        <div class="checkbox checkbox-inline">
          <input type="checkbox" name="customer" id="customer-1" value="1" v-model="customerType" />
          <label for="customer-1">壽險客戶</label>
        </div>
        <!-- <div class="checkbox checkbox-inline">
          <input type="checkbox" name="customer" id="customer-2" value="2" v-model="customerType" />
          <label for="customer-2">產險客戶</label>
        </div> -->
        <div class="checkbox checkbox-inline">
          <input type="checkbox" name="customer" id="customer-3" value="3" v-model="customerType" />
          <label for="customer-3">旅平險客戶</label>
        </div>
        <div class="checkbox checkbox-inline">
          <input type="checkbox" name="customer" id="customer-4" value="4" v-model="customerType" />
          <label for="customer-4">房貸客戶</label>
        </div>
        <div class="checkbox checkbox-inline">
          <input type="checkbox" name="customer" id="customer-5" value="5" v-model="customerType" />
          <label for="customer-5">團險客戶</label>
        </div>
        <div class="checkbox checkbox-inline">
          <input type="checkbox" name="customer" id="customer-6" value="6" v-model="customerType" />
          <label for="customer-6">準保戶</label>
        </div>
      </div>
    </section>
    <section>
      <div class="container-fluid">
        <div class="row">
          <data-table
            ref="dataTable"
            @update="updateSelection"
            @updateall="updateSelectAll"
            :options="tableOption"
            :table-data="tableDataBackup"
            :remote-data-msg="remoteDataMsg"
            :scrollDataLoading="true"
            :dynamicLoading="true"
            :hasSearchBar="false"
          />
        </div>
      </div>
    </section>

    <section class="container-fluid">
      <fixed-botton v-show="!isScroll">
        <template slot="@function">
          <div>
            <button
              type="button"
              class="btn btn-default"
              v-if="showDeleteBtn"
              @click="deleteResult"
              :disabled="!selection.length"
            >刪除客戶</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="panelOpen('confirmGroupModalOpen')"
              :disabled="!selection.length"
            >加入群組</button>
            <button
              type="button"
              class="btn btn-primary mr-0"
              @click="openPrintModal"
              :disabled="!selection.length"
            >列印名條</button>
          </div>
        </template>
      </fixed-botton>
    </section>

    <!-- 刪除客戶 -->
    <warning-modal
      :open="WarningModalOpen"
      :message="deleteWarningMessage"
      @close="panelClose('WarningModalOpen')"
      @submit="submitDeleteResult"
    />
    <!-- 警告視窗 -->
    <warning-modal
      :open="WarningDoubleCheckModalOpen"
      :message="WarningDoubleCheckModalMessage"
      :confirmText="`確認刪除`"
      @close="panelClose('WarningDoubleCheckModalOpen')"
      @submit="deleteCustomer"
    />
    <!-- 列印 -->
    <print-modal
      :open="printModalOpen"
      :custs="selectionWithMobile"
      @close="panelClose('printModalOpen')"
    />
    <!-- 確認加入群組類型視窗 -->
    <confirm-group-modal
      :open="confirmGroupModalOpen"
      title="請選擇加入群組方式"
      @close="panelClose('confirmGroupModalOpen')"
      @addToCurrentGroup="addToCurrentGroup"
      @createNewGroup="createOneGroupOpen"
    />
    <!-- 成立新的群組視窗 -->
    <create-one-group-modal
      :open="createOneGroupModalOpen"
      :selectedCust="selection"
      type="SearchResultUse"
      @close="panelClose('createOneGroupModalOpen')"
      @createOneGroup="createOneGroup"
    />
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" content="資料刪除中，請稍候..." />
  </main>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { mapActions, mapGetters } from "vuex";
//component
import PrintModal from "@/desktop/components/PrintModal";
import WarningModal from "@/desktop/components/WarningModal";
import DataTable from "@/components/DataTable/DataTableScroll";
import FixedBotton from "@/desktop/components/fixedBotton";
import mxMask from "@/desktop/components/mxMask";
import ConfirmGroupModal from "@/desktop/components/ConfirmGroupModal";
import CreateOneGroupModal from "@/desktop/components/CreateOneGroupModal";
//service
import { queryRecentCust, deleteCust, doSortList } from "@/service";

export default {
  name: "RecentCustList",
  mixins: [commonMixin],
  components: {
    PrintModal,
    WarningModal,
    DataTable,
    FixedBotton,
    mxMask,
    ConfirmGroupModal,
    CreateOneGroupModal
  },
  watch: {
    checkAll: function(val) {
      if (val && this.checkAllClick) {
        this.selection = [];
        this.tableDataBackup.forEach(data => {
          this.selection.push(data.id);
        });
      } else if (this.checkAllClick) {
        this.selection = [];
      }
    },
    selection: function() {
      if (this.tableDataBackup.length == 0) {
        this.checkAll = false;
      } else if (
        this.tableDataBackup.length !== this.selection.length &&
        !this.checkAllClick
      ) {
        this.checkAll = false;
      } else if (!this.checkAllClick) {
        this.checkAll = true;
      }
    },
    customerType: function(newAry) {
      this.$store.dispatch("updaCustType", newAry);
      let val = newAry.find(function(e) {
        return e == 6;
      });
      if (newAry.length == 1 && val == 6) {
        this.showDeleteBtn = true;
      } else {
        this.showDeleteBtn = false;
      }
      this.filterByType();
    }
  },
  computed: {
    ...mapGetters(["BaseUrl", "RouterPara"])
  },
  data() {
    return {
      act_type: "", //類型
      mxMaskOpen: false,
      orderBy: "name",
      orderAsc: true,
      //customerType: ["1", "2", "3", "4", "5", "6"],
      customerType: ["1", "3", "4", "5", "6"], //移除產險客戶
      showDeleteBtn: false,
      tableData: [],
      tableDataBackup: [],
      remoteDataMsg: "資料讀取中，請稍候...",
      confirmGroupModalOpen: false,
      createOneGroupModalOpen: false,
      printModalOpen: false,
      checkAllClick: false,
      WarningModalOpen: false,
      WarningDoubleCheckModalOpen: false,
      checkAll: false,
      selection: [],
      selectionWithMobile: [],
      deleteWarningMessage: "您確定要刪除這些「準保戶」的客戶嗎？",
      WarningDoubleCheckModalMessage:
        "系統會同步刪除「<span style='color:red;'>客戶情報</span>」、「<span style='color:red;'>保單健檢</span>」及「<span style='color:red;'>建議書</span>」相關資訊，確認刪除後資料將無法回復，請確認是否刪除？",
      checkAll_f: false,
      isScroll: false, //是否滾動
      tableOption: {
        checkAll: true,
        scrollHeight: 550,
        checkBoxHasUser: true,
        columns: [
          {
            width: 110,
            name: "name",
            label: "姓名",
            sorting: true,
            click: data => {
              this.routeToCustDetail(data.id);
            }
          },
          {
            width: 120,
            name: "showid",
            sortName: "id",
            label: "身分證",
            sorting: true
          },
          {
            width: 120,
            name: "mobile",
            label: "手機",
            sorting: true
          },
          {
            width: 130,
            name: "phone",
            label: "電話",
            sorting: true
          },
          {
            width: 100,
            name: "birthday",
            label: "生日",
            sorting: true
          },
          {
            name: "address",
            sorting: true,
            label: "住家地址"
          },
          {
            width: 101,
            name: "idmark",
            label: "公司往來"
          }
        ],
        sortByName: () => {
          this.orderAsc = !this.orderAsc;
          this.sortByName();
        }
      }
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID", "updateSerNo"]),
    updateSelection(val) {
      this.selection = val;
    },
    updateSelectAll(val) {
      this.checkAll_f = val;
    },
    deleteResult() {
      this.panelOpen("WarningModalOpen");
    },
    submitDeleteResult() {
      this.panelClose("WarningModalOpen");
      this.panelOpen("WarningDoubleCheckModalOpen");
    },
    //連至客戶個人資訊頁面
    routeToCustDetail(custId) {
      let isSerNo = custId.startsWith("~") ? true : false;
      if (!isSerNo) {
        //有ID
        this.updateCustID(custId);
        this.updateSerNo("");
        localStorage.CustID = custId;
        localStorage.SerNo = "";
        this.$router.push({ path: `/detail/CustID/tab/1` });
      } else {
        //無ID，取serNo
        this.updateSerNo(custId);
        this.updateCustID("");
        localStorage.CustID = "";
        localStorage.SerNo = custId;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    //打開列印視窗
    openPrintModal() {
      this.selectionWithMobile = [];
      this.selection.forEach(sel => {
        let tmpData = this.tableDataBackup.find(data => {
          return data.id === sel;
        });
        if (tmpData) {
          this.selectionWithMobile.push(tmpData);
        }
      });
      this.panelOpen("printModalOpen");
    },
    //過濾客戶類型
    filterByType() {
      this.checkAll = false;
      this.selection = [];
      this.tableDataBackup = [];
      setTimeout(() => {
        this.tableDataBackup = this.tableData.filter(item => {
          if (this.customerType.includes("1")) {
            if (item.customertype1 == "1") {
              return item;
            }
          }
          // if (this.customerType.includes("2")) {
          //   if (item.customertype2 == "1") {
          //     return item;
          //   }
          // }
          if (this.customerType.includes("3")) {
            if (item.customertype3 == "1") {
              return item;
            }
          }
          if (this.customerType.includes("4")) {
            if (item.customertype4 == "1") {
              return item;
            }
          }
          if (this.customerType.includes("5")) {
            if (item.customertype5 == "1") {
              return item;
            }
          }
          if (this.customerType.includes("6")) {
            if (
              item.customertype1 == "0" &&
              item.customertype2 == "0" &&
              item.customertype3 == "0" &&
              item.customertype4 == "0" &&
              item.customertype5 == "0" &&
              item.customertype6 == "1"
            ) {
              return item;
            }
          }
        });
        //重給編號
        let sn = 1;
        this.tableDataBackup.forEach(item => {
          item.index = sn;
          sn++;
        });
        this.registerHanlink(); // 難字顯示
      }, 20);
    },
    //導頁至加入現有群組(view)
    addToCurrentGroup() {
      this.panelClose("confirmGroupModalOpen");
      let selectionInfo = this.getSelectedCustInfo();
      this.$router.push({
        name: "add-to-current-group",
        params: { selectedCust: selectionInfo }
      });
    },
    //開啟成立新的群組視窗
    createOneGroupOpen() {
      this.panelClose("confirmGroupModalOpen");
      this.panelOpen("createOneGroupModalOpen");
    },
    //導頁至成立新的群組(view)
    createOneGroup(groupName) {
      let selectionInfo = this.getSelectedCustInfo();
      this.panelClose("createOneGroupModalOpen");
      this.$router.push({
        name: "create-one-group",
        params: { selectedCust: selectionInfo, groupName: groupName }
      });
    },
    //取得當前勾選客戶的資料
    getSelectedCustInfo() {
      let selectionInfo = [];
      this.selection.forEach(sel => {
        let tmpData = this.tableData.find(data => {
          return data.id === sel;
        });
        if (tmpData) {
          selectionInfo.push({
            showid: tmpData.showid,
            id: tmpData.id,
            name: tmpData.name,
            birthday: tmpData.birthday
          });
        }
      });
      return selectionInfo;
    },
    //刪除客戶
    deleteCustomer() {
      this.mxMaskOpen = true; //開啟遮罩
      deleteCust(
        this.$store.state.userInfo.id,
        "csids",
        "",
        "",
        this.selection
      ).then(result => {
        this.mxMaskOpen = false; //關閉遮罩
        if (result && result.header.status == "200") {
          this.panelClose("WarningDoubleCheckModalOpen");
          this.$toast.info({ title: `刪除成功` });
          this.$router.push({ path: `/` });
        } else {
          this.panelClose("WarningDoubleCheckModalOpen");
          this.$toast.info({ title: `刪除失敗` });
        }
      });
    },
    handleScroll() {
      // ----滾動顯示/隱藏----
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 500);
      // ----滾動顯示/隱藏----
    },
    getRecentCustList() {
      this.tableDataBackup = [];
      this.remoteDataMsg = "資料讀取中，請稍候...";
      queryRecentCust(
        this.$store.state.userInfo.id,
        this.orderBy,
        this.orderAsc ? "asc" : "desc",
        this.act_type
      )
        .then(result => {
          if (
            result.header &&
            (result.header.status == "200" || result.header.status == "0")
          ) {
            this.tableData = result.body.recentlist.map((item, index) => {
              item.index = index + 1;
              item.id = item.id || item.ser_no;
              item.showid = item.id.startsWith("~") ? "" : item.id;
              item.vip_level = Number(item.vip_lvl || "0");
              item.idage = item.age || "";
              item.is_exist = true;
              item.phone = item.home_tel_area
                ? item.home_tel_area + "-" + item.home_tel || ""
                : item.home_tel || "";
              item.address =
                (item.home_addr_zip || "") +
                (item.home_addr1 || "") +
                (item.home_addr2 || "") +
                (item.home_addr3 || "");
              item.idmark = [
                item.source1 == "1" ? "1" : "N",
                item.source2 == "1" ? "2" : "N",
                item.source3 == "1" ? "3" : "N",
                item.source4 == "1" ? "4" : "N",
                item.source5 == "1" ? "5" : "N",
                item.source6 == "1" ? "6" : "N"
              ];
              let ageText = this.paddingLeft(item.age == "0" ? "0" : item.age ? item.age : "00000", 4, "0");
              let birthdayText = item.birthday || "0000-01-01";
              item.birthdaySort = ageText + "_" + birthdayText;
              return item;
            });
          } else {
            this.tableData = [];
            this.setToastMsg(result.header.message);
          }
          this.tableDataBackup = [...this.tableData];
          this.filterByType();
        })
        .finally(() => {
          this.remoteDataMsg = "查無資料";
          this.registerHanlink(); // 難字顯示
        });
      this.tableOption.scrollHeight = $(window).height() - 240;
    },
    //依姓名筆劃排序
    sortByName() {
      if(this.tableDataBackup.length == 0) {
        return;
      }
      
      let tempData = this.tableDataBackup;
      this.tableDataBackup = [];
      this.remoteDataMsg = "資料排序中，請稍候...";
      doSortList(
        this.$store.state.userInfo.id,
        this.orderAsc ? "1" : "-1",
        tempData,
        "name"
      ).then(result => {
        if (result.header && result.header.status === "200") {
            this.tableDataBackup = result.body.result;
            this.tableDataBackup.forEach((item, index) => {
              item.index = `${index + 1}`;
            } );
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "姓名排序異常,請重新操作" });
          }
          this.tableDataBackup = tempData;
        }
        this.remoteDataMsg = "查無資料，請確認您輸入之資料是否正確";
      });
    },
  },
  async mounted() {
    //若客戶類型篩選設定有異動過，要保留前次設定內容
    let chkCustType = this.$store.state.custType;
    if (
      chkCustType &&
      (!chkCustType.includes("1") ||
        !chkCustType.includes("2") ||
        !chkCustType.includes("3") ||
        !chkCustType.includes("4") ||
        !chkCustType.includes("5") ||
        !chkCustType.includes("6"))
    ) {
      this.customerType = chkCustType;
    }
    this.act_type = this.$store.state.act_type;
    await this.getRecentCustList();
    window.addEventListener("scroll", this.handleScroll, true);
    let self = this;
    $(window).bind("resize", function() {
      self.tableOption.scrollHeight = $(window).height() - 310;
    });
  }
};
</script>
<style scoped>
.margin-left-10 {
  margin-left: 10px;
}
.margin-buttom-0 {
  margin-bottom: 0px;
  margin: 0px 0;
}
</style> 